import { Component } from 'react';
import { connect } from 'react-redux';

import CheckoutSummary from 'cart/CheckoutSummary';
import { CheckoutLayout } from 'common/components/layout';
import Footer from 'common/components/layout/Footer';
import { logEvent } from 'common/helpers/analytics';
import { checkoutStep } from 'redux/cart/actions';

import EditStep from './EditStep';
import Captcha from './components/Captcha';
import ContentSummary from './components/ContentSummary';
import Header from './components/Header';
import Message from './components/Message';
import MobileToggleSummary from './components/MobileToggleSummary';
import Prop65 from './components/Prop65';
import { calculateStep, editStep } from './helpers';

class Checkout extends Component {
  constructor(props) {
    super(props);
    const step = calculateStep(props.cart, props.settings);
    this.state = {
      isSummaryVisibleOnMobile: false,
      step,
      isLoaded: false
    };
    if (props.cart.data) {
      props.checkoutStep(step, props.cart.data);
    }
  }

  // static getDerivedStateFromProps(nextProps, prevState) {
  //   const cart = nextProps.cart && nextProps.cart.data;
  //   if (!cart) {
  //     return null;
  //   }
  //   const step = calculateStep(nextProps.cart);
  //   if (step !== prevState.step) {
  //     return { step };
  //   }
  //   return null;
  // }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { props } = this;
    if (
      (nextProps.cart.data && !props.cart.data) ||
      (nextProps.settings.data && !props.settings.data)
    ) {
      const step = calculateStep(nextProps.cart, nextProps.settings);
      this.setState({ step }, () => {
        if (nextProps.cart.data) {
          props.checkoutStep(step, nextProps.cart.data);
        }
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { props, state } = this;
    if (!state.isLoaded) {
      logEvent('Checkout', 'V1 Start');
      this.setState({ isLoaded: true });
    }
    if (!prevProps.cart.data && props.cart.data) {
      if (props.cart.data.items.length === 0) {
        // no cart items, so we redirect
        props.history.push('/cart');
      }
    }
  }

  handleEdit = (step) => {
    const { props } = this;
    const newStep = editStep(props.cart, step);
    this.setState({ step: newStep }, () => {
      props.checkoutStep(step, props.cart.data);
    });
  };

  toggleMobileSummary = () => {
    const { isSummaryVisibleOnMobile } = this.state;
    this.setState({ isSummaryVisibleOnMobile: !isSummaryVisibleOnMobile });
  };

  render() {
    const { settings, cart, customer } = this.props;
    const { isSummaryVisibleOnMobile } = this.state;
    const { step } = this.state;
    if (!settings.data || !cart.data) {
      return (
        <CheckoutLayout title="Checkout" loading>
          &nbsp;
        </CheckoutLayout>
      );
    }
    return (
      <CheckoutLayout title="Checkout">
        <MobileToggleSummary
          cart={cart.data}
          onToggleMobile={this.toggleMobileSummary}
          settings={settings}
        />
        <div className="c7-checkout">
          <CheckoutSummary
            cart={cart.data}
            isSummaryVisibleOnMobile={isSummaryVisibleOnMobile}
            settings={settings}
          />
          <div className="c7-checkout__main">
            <Header
              settings={settings}
              step={step}
              onMenuClick={this.handleEdit}
            />
            <div className="c7-checkout__content">
              <Message settings={settings} />
              <ContentSummary
                cart={cart.data}
                customer={customer.data}
                onEdit={this.handleEdit}
                currentStep={step}
                settings={settings}
              />
              <EditStep
                cart={cart.data}
                customer={customer.data}
                step={step}
                onEdit={this.handleEdit}
                settings={settings}
              />
            </div>
            <Prop65 cart={cart.data} />
            <Footer settings={settings} />
            <Captcha />
          </div>
        </div>
      </CheckoutLayout>
    );
  }
}

const mapStateToProps = (state) => ({
  cart: state.cart,
  customer: state.customer,
  settings: state.setting
});

export default connect(mapStateToProps, { checkoutStep })(Checkout);
